import { render, staticRenderFns } from "./promotion_form_update.vue?vue&type=template&id=ff1741d4&"
import script from "./promotion_form_update.vue?vue&type=script&lang=js&"
export * from "./promotion_form_update.vue?vue&type=script&lang=js&"
import style0 from "./promotion_form_update.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports